import FieldDefs from './KeysByPageFieldDefs'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'
import KeysByPageGny from "./KeysByPageGny";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.keysbypage", isGoogleGny() ? KeysByPageGny : FieldDefs),
            sortOrder: [
                {
                    field: 'pos',
                    direction: 'asc'
                },
                {
                    field: isGoogleGny() ? 'ws' : 'wsk',
                    direction: 'desc'
                },
            ],
            additionalActions: [
                {
                    label: this.$t("lang.report.concurent_pages"),
                    icon: [],
                    event: function(){
                        window.open("/" + window.locale + "/concurentpages" + window.location.search, '_blank');
                    }
                },
            ],
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
